import { gql } from 'graphql-tag';

export const GET_ORG_PAGE_QUERY = gql`
  query getOrgPage($cursor: String, $limit: Int) {
    me {
      organizationPage(cursor: $cursor, limit: $limit) {
        organizations {
          id
          name
        }
        cursor
      }
    }
  }
`;

export const FRAGMENT_ORGANIZATION_DETAILS = gql`
  fragment OrganizationDetails on Organization {
    id
    name
    businessIdentifier
    country
    currencyCode
  }
`;

export const GET_ORGANIZATION_DETAILS = gql`
  query organization($orgId: String!) {
    getOrganizationById(id: $orgId) {
      ...OrganizationDetails
    }
  }
  ${FRAGMENT_ORGANIZATION_DETAILS}
`;
